import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUsers = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M9.75 6C9.75 7.65685 8.40685 9 6.75 9C5.09315 9 3.75 7.65685 3.75 6C3.75 4.34315 5.09315 3 6.75 3C8.40685 3 9.75 4.34315 9.75 6ZM14.2499 12.75C14.2499 11.49 13.5299 10.545 12.5024 9.8475C14.5724 10.1475 17.2499 11.115 17.2499 12.75V14.25C17.2499 14.6625 16.9124 15 16.4999 15H14.2499V12.75ZM11.2499 9C12.9074 9 14.2499 7.6575 14.2499 6C14.2499 4.3425 12.9074 3 11.2499 3C10.8974 3 10.5674 3.075 10.2524 3.18C10.8749 3.9525 11.2499 4.935 11.2499 6C11.2499 7.065 10.8749 8.0475 10.2524 8.82C10.5674 8.925 10.8974 9 11.2499 9ZM0.75 12.75C0.75 10.755 4.7475 9.75 6.75 9.75C8.7525 9.75 12.75 10.755 12.75 12.75V14.25C12.75 14.6625 12.4125 15 12 15H1.5C1.0875 15 0.75 14.6625 0.75 14.25V12.75Z",
		fill: "black",
		fillOpacity: .88
	})]
});
const ForwardRef = forwardRef(SvgUsers);
export { ForwardRef as ReactComponent };
